var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMailClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_envelope-gray",
    transform: "translate(-55 -113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_30px",
    "data-name": "30px",
    width: 30,
    height: 30,
    transform: "translate(55 113)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_envelope-gray-2",
    "data-name": "icon_envelope-gray",
    d: "M19.423,68.9a.233.233,0,0,1,.375.182v7.907a1.857,1.857,0,0,1-1.856,1.856H1.856A1.857,1.857,0,0,1,0,76.992v-7.9a.231.231,0,0,1,.375-.182c.866.673,2.015,1.527,5.959,4.393.816.6,2.192,1.848,3.565,1.841,1.38.012,2.784-1.268,3.569-1.841C17.412,70.434,18.556,69.576,19.423,68.9ZM9.9,73.9c.9.015,2.189-1.129,2.838-1.6,5.131-3.724,5.522-4.048,6.7-4.976a.925.925,0,0,0,.356-.731v-.735A1.857,1.857,0,0,0,17.942,64H1.856A1.857,1.857,0,0,0,0,65.856v.735a.931.931,0,0,0,.356.731c1.183.924,1.574,1.253,6.7,4.976C7.71,72.77,9,73.914,9.9,73.9Z",
    transform: "translate(60.195 57.504)",
    fill: "#72383D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailClose);
export default __webpack_public_path__ + "static/media/icon_mail_close.fede196f3432d669a7f6d8081ef6ea47.svg";
export { ForwardRef as ReactComponent };